import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Recaptcha from 'services/recaptcha';


const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state', '$rootScope', 'UserRestService', 'Util', 'Auth'];

/**
 * @ngdoc directive
 * @name directives.controller.changeEmailController
 *
 * @description
 * change email controller
 */
class ChangeEmailController {

    /**
     * @param  {any} $scope
     * @param  {any} $state
     * @param  {any} UserRestService
     * @param  {any} Util
     * @param  {any} $rootScope
     * @param  {any} Auth
     */
    constructor($scope, $state, $rootScope, UserRestService, Util, Auth) {

        this.$scope = $scope;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.MeRepository = MeRepository;
        this.UserRestService = UserRestService;
        this.Util = Util;
        this.Auth = Auth;
        this.Recaptcha = Recaptcha;
        this.user = MeRepository.getMyUser();

        this.$scope.submitted = false;
        this.$scope.loading = false;
        this.$scope.emailError = false;
        this.$scope.emailRegExp = this.Util.getEmailValidationRegExp();
        this.$scope.email = this.user.attributes.email;
        this.$scope.password = null;
        this.$scope.loginFailedAttempts = 0;
        this.$scope.captchaRequired = 0;
        this.$scope.$parent.setCaptchaResponse = this.setCaptchaResponse.bind(this);
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        // MeRepository Observable
        const meRepositoryObservable = MeRepository.getObservable();
        const onNextMeRepository = () => {

            this.user = MeRepository.getMyUser();

        };

        this.meRepositorySubscriber = meRepositoryObservable.subscribe(
            onNextMeRepository,
            () => { },
            () => { },
        );
        this.$scope.$on('captcha available', () => this.setCaptchaResponse());

    }

    // check if the current email and the entered one are different
    checkEmailAddresses() {

        this.$scope.isEmailDifferent = this.$scope.email !== this.user.attributes.email;

    }


    changeEmail() {

        Mixpanel.send('ConnectWeb Change Email Click');

        const headers = {};

        const captchaRespose = this.Recaptcha.getCaptchaResponse();

        if (captchaRespose) {

            headers['X-Avira-Captcha-Token'] = captchaRespose;

        }

        const payload = {
            data: {
                id: this.user.id,
                attributes: {
                    email: this.$scope.email,
                },
                relationships: {
                    provider: {
                        data: {
                            type: this.user.relationships.partner.data.type,
                            id: this.user.relationships.partner.data.id,
                        },
                    },
                },
                type: this.user.type,
            },
            meta: {
                language: CWCONFIG.language,
                password: this.$scope.changeEmailForm.password.$viewValue,
            },
        };

        this.checkEmailAddresses();
        this.$scope.changeEmailForm.password.$setValidity('serverValidation', true);
        /* beside form validation, we also check if the email addresses
        are different in order to validate the form */
        const formIsValid = this.$scope.changeEmailForm.$valid && this.$scope.isEmailDifferent;
        this.$scope.changeEmailForm.$setPristine();
        this.$scope.submitted = true;
        this.$scope.loading = true;

        if (formIsValid) {

            this.UserRestService.update(this.user.id, payload, headers).then(() => {

                this.$scope.password = null;
                this.$scope.loading = false;
                this.$scope.submitted = false;
                this.$scope.emailError = false;
                this.Recaptcha.disableCaptcha();

            }).then(null, (error) => {

                const errorCode =
                    (error.data.errors && error.data.errors[0]) ? error.data.errors[0].code : false;

                this.$scope.loading = false;

                switch (errorCode) {

                // email already exists
                case '21112':
                    this.$scope.submitted = true;
                    this.$scope.emailError = true;


                    break;

                    // open modal and enter the received code
                case '21118':

                    this.$scope.emailError = false;
                    this.$scope.submitted = false;
                    this.$scope.password = null;

                    this.$state.go('root.dashboard.my-account.ltb', {
                        ltb: 'change-email',
                    });

                    // save email information on $rootScope in order to use it in Change Email modal
                    this.$rootScope.changeEmail = {
                        currentEmail: this.user.attributes.email,
                        newEmail: this.$scope.email,
                        kp: this.$scope.changeEmailForm.password.$viewValue,
                    };

                    break;

                // invalid credential
                case '21133':

                    this.$scope.loginFailedAttempts += 1;
                    this.$scope.changeEmailForm.password.$setPristine();
                    this.$scope.changeEmailForm.password.$setValidity('serverValidation', false);

                    break;

                // captcha is required
                case '918':

                    if (this.$scope.captchaRequired >= 2) {

                        this.$state.reload();
                        Alert.error('cw.auth.tfa.error.retries_exceeded');

                    }

                    this.Recaptcha.execute();
                    this.$scope.captchaRequired += 1;
                    break;

                default:

                    Alert.error('cw.account.details.messages.error');

                }

                this.Util.triggerAnimation('.error', 'animated shake');

            });

        } else {

            this.$scope.loading = false;
            this.Util.triggerAnimation('.error', 'animated shake');

        }

    }

    onSubmit() {

        if (this.Recaptcha.isCaptchaRequired()) {

            this.Recaptcha.execute();

        } else {

            this.changeEmail();

        }

    }

    setCaptchaResponse() {

        this.changeEmail();

    }

    showPassword() {

        const input = angular.element('#password')[0];

        input.type = input.type === 'text' ? 'password' : 'text';

        this.$scope.inputType = input.type;

    }
    setEmail() {

        this.$rootScope.forgotEmail = this.user.attributes.email;

    }

}

/**
 * @ngdoc directive
 * @name directives.changeEmailDirective
 *
 * @description
 * change email directive
 */
class ChangeEmailDirective {

    constructor() {

        this.template = require('./change-email.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push((
            $scope, $state, $rootScope,
            UserRestService, Util, Auth,
        ) =>
            new ChangeEmailController(
                $scope, $state, $rootScope,
                UserRestService, Util, Auth,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'changeEmailCtrl';

    }

}

_directiveDependencies.push(() => new ChangeEmailDirective());


angular.module('directives')
    .directive('changeEmail', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/security/change-email/change-email.js